import React, {useEffect, useState} from 'react';
import FilterCheckBox from '../FilterCheckBox';
import FilterPopover from "../FilterPopover";
import {Button} from "ui";
import {FormattedMessage} from "react-intl";
import {useSession} from "hooks/Lectures/useSession";

type FilterDataMap = Record<string, unknown>;

interface SessionFilterInterface {
    tagBuilder: Function;
    session?: any;
    setFilterValues: any;
    filterValues: any
    form: any;
    filterKey: string;
    setFilterKey: React.Dispatch<React.SetStateAction<string>>;
}

const SessionFilter: React.FC<SessionFilterInterface> = ({
                                                             filterKey,
                                                             setFilterKey,
                                                             form,
                                                             tagBuilder,
                                                             setFilterValues,
                                                             filterValues
                                                         }) => {
    const {searchSession, sessionLoading: isLoading} = useSession()
    const [data, setData] = useState<FilterDataMap>({});
    const [initialValues, setInitialValues] = useState(undefined)
    const key = 'sessions'

    useEffect(() => {
        onSearch('')
    },[])

    const onSearch = async (value: string) => {
        const response = await searchSession(value)
        const safeResponse: FilterDataMap =
            response && typeof response === 'object' && !Array.isArray(response) ? response : {};
        setData(safeResponse);
        setFilterValues(
            {
                ...filterValues,
                session: {
                    ...filterValues.session,
                    ...safeResponse
                }
            }
        )
    };

    const content = (
        <>
            <FilterCheckBox data={data} name={'session'} onSearch={onSearch}/>
            <div className={'flex justify-between p-1'}>
                <Button type={'link'} onClick={() => handleClose()} message='general.cancel' />
                <Button type={'primary'} onClick={() => {
                                        setFilterKey('')

                    handleOpen(false)
                }} message='general.select' />
            </div>
        </>
    );

    const handleClose = () => {
        form.setFieldsValue(initialValues);
                            setFilterKey('')
;
    }

    const handleOpen = (open: boolean) => {
        if (open) {
            setInitialValues(form.getFieldsValue())
            setFilterValues(
                {
                    ...filterValues,
                    session: {
                        ...filterValues.session,
                        ...data
                    }
                }
            )
        } else {
            tagBuilder()
        }
    }

    return (
        <FilterPopover
            popoverKey={key}
            filterKey={filterKey}
            setOpen={setFilterKey}
            handleOpen={handleOpen}
            content={content}
            loading={isLoading}
            title={'general.search_by_session'}
            buttonTitle={'general.session'}
        />
    );
};

export default SessionFilter;